import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { StepVariantResponseSchema } from '../../entities/step-variant-response';
import { VariantCheckAnswerSchema } from '../../entities/survey';
/**
 * Submit Variant Response Request Schema
 * POST /api/v2/process-step-recording/:id/variant-response
 * Step recording ID provided as URL parameter; the responder is the caller.
 *
 * `description` stays optional here because it is mandatory only for
 * `different` — a conditional the service enforces, so the rejection can name
 * the field (see the contract's error matrix).
 */ export const SubmitVariantResponseRequestSchema = z.object({
    answer: VariantCheckAnswerSchema,
    description: z.string().optional()
});
/**
 * Submit Variant Response Response Schema
 * Returned on a successful answer; carries the stored, immutable response
 */ export const SubmitVariantResponseResponseSchema = z.object({
    variantResponse: StepVariantResponseSchema
});
/**
 * Submit Variant Response Error Schema
 * Returned when the answer is refused — see the contract's error matrix
 */ export const SubmitVariantResponseErrorSchema = BaseErrorSchema;

//# sourceMappingURL=submit-variant-response.schema.js.map